import { SelectorDataTable } from './SelectorDataTable';
import type { ColumnDef } from '../types';
import type { UsePagedAsyncSuggestionsResult } from '../search/usePagedAsyncSuggestions';

export interface SelectorPickerContentProps<TItem> {
  mode: 'single' | 'multi';
  columns: readonly ColumnDef<TItem>[];
  selected: readonly TItem[];
  onSelect: (item: TItem) => void;
  onToggleSelection?: (item: TItem) => void;
  getKey?: (item: TItem) => string | number;
  suggestions: UsePagedAsyncSuggestionsResult<TItem>;
}

/** Tabulka pick modalu — stránkování řeší patička modalu (SelectorPickModalFooter). */
export function SelectorPickerContent<TItem>({
  mode,
  columns,
  selected,
  onSelect,
  onToggleSelection,
  getKey,
  suggestions,
}: SelectorPickerContentProps<TItem>) {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-auto">
        <SelectorDataTable
          items={suggestions.items}
          columns={columns}
          mode={mode}
          selected={selected}
          onSelect={onSelect}
          onToggleSelection={mode === 'multi' ? onToggleSelection : undefined}
          getKey={getKey}
          sort={suggestions.sort}
          onSortChange={suggestions.setSort}
          isLoading={suggestions.isLoading}
          isError={suggestions.isError}
        />
      </div>
    </div>
  );
}
